module.exports = __webpack_public_path__ + "img/ivTest_sub50.f3d24f18.png";